module.exports = __webpack_public_path__ + "static/media/Portuguese_European_Ines BG-44.00671472.png";